import { ChangeDetectionStrategy, Component, InputSignal, Signal, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { IconDirective } from '@core/shared/util';
import { SupplierCategory, SupplierType } from '@mp/supplier-management/common/domain';

import { SupplierCategoryKey } from '../../models';

import { SupplierIconNamePipe } from './supplier-icon-name.pipe';

@Component({
  selector: 'mpsm-supplier-icon',
  templateUrl: './supplier-icon.component.html',
  styleUrl: './supplier-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, SupplierIconNamePipe, IconDirective],
})
export class SupplierIconComponent {
  readonly type: InputSignal<SupplierType> = input.required<SupplierType>();
  readonly category: InputSignal<SupplierCategory | undefined | null> = input<SupplierCategory | null>();

  supplierCategoryKey: Signal<SupplierCategoryKey | null> = computed<SupplierCategoryKey | null>(() =>
    this.getSupplierIcon(),
  );

  private getSupplierIcon(): SupplierCategoryKey | null {
    if (this.type() === SupplierType.ClinicSupplier) {
      return 'ClinicSupplier';
    }

    const category = this.category();

    if (category) {
      return SupplierCategory[category] as SupplierCategoryKey;
    }

    return null;
  }
}
